import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';

import Image from '../Image';
import { IconClose, IconMinus, IconPlus } from '../Icons';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import { StyledLi, StyledImageWrapper, StyledTextDiv, StyledLineItemTitle, StyledCustomAttribute, StyledCartQuantitySelector, StyledLineItemPrice, StyledFullPrice, StyledRemoveButton, StyledIsLoadingWrapper } from './LineItemStyles';
import { StyledInput, StyledButton } from '../QuanititySelector/QuantitySelectorStyles';

import { getPreorderData } from '../../Utils/VariantUtils';
import { getCurrency } from '../../Utils/PriceUtils';

var _ref = React.createElement(
  StyledCustomAttribute,
  { lowercase: true },
  'Not eligible for discounts'
);

var _ref2 = React.createElement(
  StyledCustomAttribute,
  { preorderMessage: true },
  'Oversized Item: Additional Shipping Cost Incurred at Checkout'
);

var _ref3 = React.createElement(IconMinus, null);

var _ref4 = React.createElement(IconPlus, null);

var
// Position loading animation over quantity selector
_ref5 = React.createElement(
  StyledIsLoadingWrapper,
  null,
  React.createElement(LoadingSpinner, null)
);

var _ref6 = React.createElement(IconClose, null);

var LineItem = function LineItem(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isRemovedFromCart = _useState4[0],
      setIsRemovedFromCart = _useState4[1];

  var decrementQuantity = function decrementQuantity() {
    props.updateLineItemInCart(props.lineItem.id, props.lineItem.quantity - 1);
    setIsLoading(true);
  };

  var incrementQuantity = function incrementQuantity() {
    props.updateLineItemInCart(props.lineItem.id, props.lineItem.quantity + 1);
    setIsLoading(true);
  };

  var removeItem = function removeItem() {
    // remove item and animate
    props.removeLineItemInCart(props.lineItem.id);
    setIsRemovedFromCart(true);
  };

  useEffect(function () {
    setIsLoading(false);
  }, [props.lineItem.quantity]);

  var preorderData = getPreorderData(props.lineItem.variant.preorderDate);

  var productPreorderObj = props.lineItem.customAttributes.find(function (attr) {
    return attr.key === '_productPreorder';
  });

  var productPreorderData = productPreorderObj ? getPreorderData(JSON.parse(productPreorderObj.value)) : null;

  var customCollectionAttribute = props.lineItem.customAttributes.find(function (attr) {
    return attr.key === '_cc';
  });

  var monogramAttribute = props.lineItem.customAttributes.find(function (attr) {
    return attr.key === 'Text';
  });

  var virtualGiftCardAttributes = props.lineItem.customAttributes.some(function (attr) {
    return attr.key.includes('_vgc');
  }) && props.lineItem.customAttributes.filter(function (attr) {
    return attr.key.includes('_vgc');
  });

  // For Shipping Surcharge lineItem copy
  // #TEMPSHIPPINGSURCHARGE
  var shippingSurchargeAttribute = props.lineItem.customAttributes.find(function (attr) {
    return attr.key === '_shippingSurcharge';
  });

  var notEligibleDiscount = props.lineItem.customAttributes.find(function (attr) {
    return attr.key === '_notEligibleDiscount';
  });

  var itemFullPrice = getCurrency(props.lineItem.variant.priceV2.currencyCode, props.lineItem.quantity * props.lineItem.variant.priceV2.amount);

  var itemSalePrice = props.lineItem.discountAllocations.length ? getCurrency(props.lineItem.discountAllocations[0].allocatedAmount.currencyCode, props.lineItem.quantity * props.lineItem.variant.priceV2.amount - props.lineItem.discountAllocations[0].allocatedAmount.amount) : null;

  var donateProduct = window.Dormify.donateADollarProduct;

  var productHref = // check if lineItem is donateProduct
  donateProduct && props.lineItem.variant.product.handle === donateProduct.handle ? '/pages/dormify-doing-good' : '/products/' + props.lineItem.variant.product.handle;

  return React.createElement(
    StyledLi,
    { removed: isRemovedFromCart },
    React.createElement(
      StyledImageWrapper,
      { href: productHref },
      props.lineItem.variant.image ? React.createElement(Image, {
        src: props.lineItem.variant.image.src,
        alt: '' + props.lineItem.title
      }) : null
    ),
    React.createElement(
      StyledTextDiv,
      null,
      React.createElement(
        StyledLineItemTitle,
        { href: productHref },
        props.lineItem.title
      ),
      React.createElement(
        StyledCustomAttribute,
        null,
        props.lineItem.variant.title != 'Default Title' && props.lineItem.variant.title
      ),
      preorderData && preorderData.isInFuture && React.createElement(
        StyledCustomAttribute,
        {
          lowercase: true,
          preorderMessage: true
        },
        'Item will ship by ' + preorderData.string + ' '
      ),
      productPreorderData && productPreorderData.isInFuture && React.createElement(
        StyledCustomAttribute,
        {
          lowercase: true,
          preorderMessage: true
        },
        'Item will ship by ' + productPreorderData.string + ' '
      ),
      monogramAttribute && React.createElement(
        StyledCustomAttribute,
        null,
        'Text: ' + monogramAttribute.value
      ),
      customCollectionAttribute && React.createElement(
        StyledCustomAttribute,
        null,
        'Collection: ' + customCollectionAttribute.value
      ),
      virtualGiftCardAttributes && React.createElement(
        Fragment,
        null,
        React.createElement(
          StyledCustomAttribute,
          { lowercase: true },
          'From: ' + virtualGiftCardAttributes.find(function (attr) {
            return attr.key === '_vgcSenderEmail';
          }).value
        ),
        React.createElement(
          StyledCustomAttribute,
          { lowercase: true },
          'To: ' + (virtualGiftCardAttributes.some(function (attr) {
            return attr.key === '_vgcRecipientEmail';
          }) ? virtualGiftCardAttributes.find(function (attr) {
            return attr.key === '_vgcRecipientEmail';
          }).value : 'Me')
        )
      ),
      notEligibleDiscount && _ref,
      shippingSurchargeAttribute && _ref2
    ),
    !virtualGiftCardAttributes && React.createElement(
      StyledCartQuantitySelector,
      { isLoading: isLoading },
      React.createElement(
        StyledInput,
        null,
        props.lineItem.quantity
      ),
      React.createElement(
        StyledButton,
        {
          onClick: decrementQuantity,
          disabled: props.lineItem.quantity === 1,
          'aria-disabled': props.lineItem.quantity === 1,
          'aria-label': 'Decrease Quantity'
        },
        _ref3
      ),
      React.createElement(
        StyledButton,
        {
          onClick: incrementQuantity,
          'aria-label': 'Increase Quantity'
        },
        _ref4
      ),
      isLoading && _ref5
    ),
    React.createElement(
      StyledLineItemPrice,
      null,
      itemSalePrice && React.createElement(
        'p',
        null,
        itemSalePrice
      ),
      React.createElement(
        StyledFullPrice,
        { lineThrough: itemSalePrice || false },
        itemFullPrice
      )
    ),
    React.createElement(
      StyledRemoveButton,
      { onClick: removeItem },
      _ref6,
      'REMOVE'
    )
  );
};

LineItem.propTypes = {
  lineItem: PropTypes.object,
  updateLineItemInCart: PropTypes.func.isRequired,
  removeLineItemInCart: PropTypes.func.isRequired
};

export default LineItem;